import axios, { AxiosRequestConfig, AxiosPromise } from "axios";
import { flaskRequestHeaders, flaskReqErrorHandler, gatewayRequestHeaders, gatewayReqErrorHandler } from "./decorators";
import { isInstanceOfUri } from "./fleetlogicAPI";
import { applyGzipMiddleware } from "./GzipMiddleware";

interface ReqOptions {
  /** Show message in the FlashMessage component */
  showMessage?: boolean;
  /** Success message to display in the FlashMessage component */
  message?: string;
}

class FlaskReqClass {
  constructor(config: AxiosRequestConfig, options?: ReqOptions) {
    return FlaskReqClass.request(config, options);
  }

  @flaskRequestHeaders
  @flaskReqErrorHandler
  static async request(config, _options) {
    const requestConfig = applyGzipMiddleware(config);

    if (config?.headers) {
      requestConfig.headers = {
        "Cache-Control": "no-cache",
        ...config.headers
      };
    }

    if (isInstanceOfUri(requestConfig)) {
      requestConfig.url = requestConfig.url.toString();
    }

    return axios(requestConfig);
  }
}

class GatewayReqClass {
  constructor(config: AxiosRequestConfig, options?: ReqOptions) {
    return GatewayReqClass.request(config, options);
  }

  @gatewayRequestHeaders
  @gatewayReqErrorHandler
  static request(config, _options) {
    const requestConfig = applyGzipMiddleware(config);
    requestConfig.headers = {
      ...config.headers
    };

    if (isInstanceOfUri(requestConfig)) {
      requestConfig.url = requestConfig.url.toString();
    }

    return axios(requestConfig);
  }
}

export function FlaskReq<Response = any>(
  config: AxiosRequestConfig,
  options?: {
    /** Show message in the FlashMessage component */
    showMessage?: boolean;
    /** Success message to display in the FlashMessage component */
    message?: string;
  }
) {
  return new FlaskReqClass(config, options) as AxiosPromise<Response>;
}

export function GatewayReq<Response = any>(
  config: AxiosRequestConfig,
  options?: {
    /** Show message in the FlashMessage component */
    showMessage?: boolean;
    /** Success message to display in the FlashMessage component */
    message?: string;
  }
) {
  return new GatewayReqClass(config, options) as AxiosPromise<Response>;
}
